import { useEffect, useState, useRef } from "react"
import { renderHoursChanel } from "utils/time"
import DropdownDate from "components/DropdownDate"
import { addDays } from "utils/time"
import Loading from "components/ui/Loading"
import { apiChannel } from "api"
import classNames from "classnames"
import { notification } from "components/ui"
import { getTracking } from "hooks/useTracking"
import { detectPlatform } from "utils/helper"

function convertEvent(obj) {
  return {
    ...obj,
    thumbnail: obj?.image,
    url: obj?.is_live ? obj?.channel?.url : obj?.catch_up_link,
    is_protected: obj?.channel?.is_protected,
    name: obj?.title,
    start_time: obj?.start,
    posterUrl: obj?.image,
    content_id: obj?.channel?.content_id,
    league_id: obj?.channel?.league_id,
    type: obj?.channel?.type
  }
}

export default function BoxRelatedTo({ event_id, platform, onChangePlay }) {
  const [loading, setLoading] = useState(false)
  const [rows, setRows] = useState([])
  const [height, setHeight] = useState(400)
  const [selected, setSelected] = useState()
  // const [day, setDay] = useState(addDays(0).date)
  const __params = useRef({
    date: addDays(0).date,
    event_id,
    platform: platform || detectPlatform()
  })
  const __time = useRef()
  const wapper = useRef()

  async function fetch(isChangeChannel) {
    // console.log("xxx", isChangeChannel)
    let _rows = []
    try {
      setLoading(true)
      const { data } = await apiChannel.getBroadcast(__params.current)
      if (data?.length > 0) _rows = data
      const itemLive = data?.find((i) => i.is_live)
      if (itemLive) {
        setSelected(itemLive.id)
        // console.log();
        if (isChangeChannel) onChangePlay(convertEvent(itemLive))
        __time.current = setTimeout(() => {
          var el = document.getElementById(`item-${itemLive.id}`)
          wapper.current?.scrollTo({
            top: el?.offsetTop - 60,
            behavior: "smooth"
          })
        }, 250)
      } else {
        if (isChangeChannel) onChangePlay(false)
      }
    } catch (error) {
      console.log(error)
      if (isChangeChannel) onChangePlay(false)
    } finally {
      setRows(_rows)
      setLoading(false)
    }
  }
  function onPlay(v, isPreview, isPartTime) {
    if (isPreview) {
      onChangePlay(convertEvent(v))
      setSelected(v.id)
      getTracking()?.sendEvent({
        event_name: "page_view",
        page_name: "Trình phát video",
        page_id: "player_vod",
        page_path: window.location.pathname + window.location.search
      })
    } else if (v.is_live) {
      onChangePlay(convertEvent(v))
      setSelected(v.id)
      getTracking()?.sendEvent({
        event_name: "page_view",
        page_name: "Trình phát trực tiếp",
        page_id: "player_live",
        page_path: window.location.pathname + window.location.search
      })
    } else {
      if (isPartTime) notification.warring({ message: "Nội dung không hỗ trợ phát lại" })
    }
  }
  function onChangeDay(v) {
    __params.current.date = v
    fetch()
  }

  useEffect(() => {
    __params.current.event_id = event_id
    if (addDays(0).date === __params.current.date) {
      fetch(true)
    } else {
      __params.current.date = addDays(0).date
      fetch(true)
    }
  }, [event_id])

  useEffect(() => {
    const el = document.getElementById("container")
    if (el) setHeight(el.offsetHeight)
    function setH() {
      setHeight(el.offsetHeight)
    }
    window.addEventListener("resize", setH)
    return () => {
      clearTimeout(__time.current)
      window.removeEventListener("resize", setH)
    }
  }, [])

  return (
    <div className="bg-dark rounded relative">
      <Loading loading={loading}>
        <div className="flex text-dark-100 bg-white/20 justify-between px-4 py-3 border-b border-gray-700">
          <div className="text-lg font-medium border-b-4 border-blue-500">Lịch phát sóng</div>
          <div>
            <DropdownDate day={__params.current.date} onChange={onChangeDay} />
          </div>
        </div>

        <div className="py-4 overflow-auto scroll__video" id="abc" style={{ height: height - 59 }} ref={wapper}>
          {rows?.length > 0 ? (
            rows?.map((item) => {
              const { title, id, start, is_live, is_catchup, catch_up_link } = item
              const isPartTime = checkTimeNow(start)
              const __class = isPartTime ? "text-dark-100 cursor-pointer" : "text-dark-500"
              const isPreview = !is_live && is_catchup && isPartTime && catch_up_link
              return (
                <div
                  id={`item-${id}`}
                  className={classNames(__class, "flex gap-2 px-4 justify-between text-sm py-3", {
                    "bg-white/10": id === selected
                  })}
                  key={id}
                  onClick={() => onPlay(item, isPreview, isPartTime)}
                >
                  <div className="font-bold min-w-[45px]">{renderHoursChanel(start)}</div>
                  <div className="flex-grow">{title}</div>
                  <div className="min-w-[45px] flex items-center justify-end">
                    {is_live && <button>{icLive}</button>}
                    {isPreview && (
                      <button className="flex items-center justify-center w-full h-full">{iconPlay}</button>
                    )}
                  </div>
                </div>
              )
            })
          ) : (
            <div className="text-sm text-dark-300 text-center mt-10">Lịch phát sóng đang được cập nhật</div>
          )}
        </div>
      </Loading>
    </div>
  )
}

function checkTimeNow(start) {
  var endDate = new Date()
  var startDate = new Date(start)
  return endDate.getTime() - startDate.getTime() > 0 ? true : false
}

const iconPlay = (
  <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="16" rx="4" fill="white" fillOpacity="0.04" />
    <path
      d="M12 14C15.3084 14 18 11.3084 18 8H16.8327C16.8327 10.6648 14.6648 12.8327 12 12.8327C9.33522 12.8327 7.16728 10.6648 7.16728 8C7.16728 5.33522 9.33522 3.16728 12 3.16728C13.3892 3.16728 14.7026 3.77162 15.6109 4.78944L14.5236 4.8731L14.6131 6.03695L17.1657 5.84058L17.7315 3.34381L16.593 3.0858L16.4027 3.92589C15.2788 2.71562 13.6844 2 12 2C8.69159 2 6 4.69159 6 8C6 11.3084 8.69159 14 12 14Z"
      fill="white"
      fillOpacity="0.6"
    />
    <path
      d="M10.2 11L15 8L10.2 5V11ZM11.3344 7.03714L12.875 8L11.3344 8.96286V7.03714Z"
      fill="white"
      fillOpacity="0.6"
    />
  </svg>
)

const icLive = (
  <svg width="40" height="14" viewBox="0 0 40 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="0.5" width="40" height="13" rx="4" fill="white" fillOpacity="0.87" />
    <circle cx="9" cy="7" r="3" fill="#EF4035" />
    <path
      d="M16.72 10.5V4.2H17.476V9.816H20.662V10.5H16.72ZM21.6331 10.5V4.2H22.3891V10.5H21.6331ZM25.2344 10.5L23.3354 4.2H24.1184L25.8374 10.041H25.9544L27.6734 4.2H28.4564L26.5574 10.5H25.2344ZM29.4026 10.5V4.2H33.2816V4.884H30.1586V6.99H33.0296V7.674H30.1586V9.816H33.3266V10.5H29.4026Z"
      fill="#000E2B"
    />
  </svg>
)
